<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {
      taskList: [
        { taskId: "Activity_07czbgn", taskName: "优化措施话术" },
        { taskId: "Activity_1i98y04", taskName: "根因分析-审批" },
        { taskId: "Activity_1qfcij8", taskName: "永久方案-优化市场话术" }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
